<div class="field field-single-check d-flex flex-column align-items-start">
  <div (click)="(check())" [class.active]="model" class="check-wrap" [style.height]="height">
    <span class="fake-checkbox"></span>
    <div class="check-title">
      @if (title1) {
        <span class="title">{{ title1 }}</span>
        }&nbsp;
        @if (title2) {
          <span class="title link" (click)="routeToTermsOfUse($event)">{{ title2 }}</span>
          }&nbsp;
          @if (title3) {
            <span class="title">{{ title3 }}</span>
            }&nbsp;
            @if (title4) {
              <span class="title link" (click)="routeToPrivacyPolicy($event)">{{ title4 }}</span>
            }
          </div>
        </div>
      </div>